/**
 * opora-fed-pop-locales.js — SCA place-of-performance counties/cities by state.
 * Validates county/city against selected state; surfaces SAM.gov WD numbers where known.
 * Verify active WD on SAM.gov before bidding.
 */
(function (global) {
  'use strict';

  var STATE_NAMES = {
    AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
    CO: 'Colorado', CT: 'Connecticut', DC: 'District of Columbia', DE: 'Delaware',
    FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', IA: 'Iowa', ID: 'Idaho', IL: 'Illinois',
    IN: 'Indiana', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', MA: 'Massachusetts',
    MD: 'Maryland', ME: 'Maine', MI: 'Michigan', MN: 'Minnesota', MO: 'Missouri',
    MS: 'Mississippi', MT: 'Montana', NC: 'North Carolina', ND: 'North Dakota',
    NE: 'Nebraska', NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico',
    NV: 'Nevada', NY: 'New York', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon',
    PA: 'Pennsylvania', PR: 'Puerto Rico', RI: 'Rhode Island', SC: 'South Carolina',
    SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VA: 'Virginia',
    VT: 'Vermont', WA: 'Washington', WI: 'Wisconsin', WV: 'West Virginia', WY: 'Wyoming'
  };

  /** @type {Array<{s:string,c:string,wd?:string,a?:string[]}>} */
  var LOCALES = [
    { s: 'TX', c: 'Harris', wd: '2015-5233', a: ['houston', 'pasadena', 'baytown', 'sugar land'] },
    { s: 'TX', c: 'Dallas', wd: '2015-5227', a: ['dallas', 'irving', 'garland', 'richardson'] },
    { s: 'TX', c: 'Tarrant', a: ['fort worth', 'arlington', 'grand prairie'] },
    { s: 'TX', c: 'Bexar', a: ['san antonio', 'lackland', 'lackland afb'] },
    { s: 'TX', c: 'Travis', a: ['austin'] },
    { s: 'TX', c: 'El Paso', a: ['el paso', 'fort bliss'] },
    { s: 'TX', c: 'Collin', a: ['plano', 'mckinney', 'frisco', 'allen'] },
    { s: 'TX', c: 'Denton', a: ['denton', 'lewisville'] },
    { s: 'TX', c: 'Fort Bend', a: ['sugar land', 'missouri city'] },
    { s: 'TX', c: 'Montgomery', a: ['the woodlands', 'conroe'] },
    { s: 'TX', c: 'Williamson', a: ['round rock', 'cedar park', 'georgetown'] },
    { s: 'TX', c: 'Cameron', a: ['brownsville', 'harlingen'] },
    { s: 'TX', c: 'Hidalgo', a: ['mcallen', 'edinburg', 'mission'] },
    { s: 'TX', c: 'Nueces', a: ['corpus christi'] },
    { s: 'TX', c: 'Webb', a: ['laredo'] },
    { s: 'TX', c: 'Bell', a: ['killeen', 'temple'] },
    { s: 'TX', c: 'Lubbock', a: ['lubbock'] },
    { s: 'TX', c: 'Jefferson', a: ['beaumont', 'port arthur'] },
    { s: 'TX', c: 'Galveston', a: ['galveston'] },
    { s: 'TX', c: 'Brazoria', a: ['pearland'] },
    { s: 'TX', c: 'Midland', a: ['midland'] },
    { s: 'TX', c: 'Ector', a: ['odessa'] },
    { s: 'TX', c: 'Pecos', a: ['fort stockton'] },
    { s: 'TX', c: 'Smith', a: ['tyler'] },
    { s: 'TX', c: 'Potter', a: ['amarillo'] },
    { s: 'TX', c: 'Randall', a: ['amarillo'] },
    { s: 'NV', c: 'Clark', wd: '2015-5593', a: ['las vegas', 'henderson', 'north las vegas', 'paradise', 'boulder city'] },
    { s: 'NV', c: 'Washoe', a: ['reno', 'sparks'] },
    { s: 'CA', c: 'Los Angeles', a: ['los angeles', 'long beach', 'glendale', 'pasadena'] },
    { s: 'CA', c: 'San Diego', wd: '2015-5635', a: ['san diego', 'chula vista'] },
    { s: 'CA', c: 'Orange', a: ['anaheim', 'santa ana', 'irvine', 'orange'] },
    { s: 'CA', c: 'Santa Clara', wd: '2015-5641', a: ['san jose', 'sunnyvale', 'santa clara'] },
    { s: 'CA', c: 'Alameda', a: ['oakland', 'fremont', 'berkeley'] },
    { s: 'CA', c: 'Sacramento', wd: '2015-5631', a: ['sacramento', 'roseville', 'folsom'] },
    { s: 'CA', c: 'San Francisco', a: ['san francisco'] },
    { s: 'CA', c: 'Contra Costa', a: ['concord', 'richmond'] },
    { s: 'CA', c: 'Riverside', a: ['riverside', 'corona'] },
    { s: 'CA', c: 'San Bernardino', a: ['san bernardino', 'ontario'] },
    { s: 'CA', c: 'Fresno', a: ['fresno'] },
    { s: 'FL', c: 'Miami-Dade', a: ['miami', 'hialeah', 'miami-dade'] },
    { s: 'FL', c: 'Broward', a: ['fort lauderdale', 'hollywood', 'pompano beach'] },
    { s: 'FL', c: 'Orange', a: ['orlando'] },
    { s: 'FL', c: 'Hillsborough', a: ['tampa'] },
    { s: 'FL', c: 'Duval', a: ['jacksonville'] },
    { s: 'FL', c: 'Pinellas', a: ['st petersburg', 'st. petersburg', 'clearwater'] },
    { s: 'FL', c: 'Lee', a: ['cape coral', 'fort myers'] },
    { s: 'FL', c: 'Palm Beach', a: ['west palm beach', 'boca raton'] },
    { s: 'GA', c: 'Fulton', a: ['atlanta'] },
    { s: 'GA', c: 'DeKalb', a: ['decatur'] },
    { s: 'GA', c: 'Cobb', a: ['marietta'] },
    { s: 'GA', c: 'Gwinnett', a: ['lawrenceville'] },
    { s: 'GA', c: 'Chatham', a: ['savannah'] },
    { s: 'NY', c: 'New York', a: ['new york', 'manhattan', 'brooklyn', 'queens', 'bronx', 'staten island'] },
    { s: 'NY', c: 'Kings', a: ['brooklyn'] },
    { s: 'NY', c: 'Queens', a: ['queens'] },
    { s: 'NY', c: 'Monroe', wd: '2015-4161', a: ['rochester'] },
    { s: 'NY', c: 'Erie', a: ['buffalo'] },
    { s: 'NY', c: 'Albany', a: ['albany'] },
    { s: 'IL', c: 'Cook', a: ['chicago'] },
    { s: 'IL', c: 'DuPage', a: ['naperville', 'wheaton'] },
    { s: 'IL', c: 'Lake', a: ['waukegan'] },
    { s: 'PA', c: 'Philadelphia', wd: '2015-4233', a: ['philadelphia'] },
    { s: 'PA', c: 'Allegheny', wd: '2015-4235', a: ['pittsburgh'] },
    { s: 'OH', c: 'Cuyahoga', wd: '2015-4727', a: ['cleveland'] },
    { s: 'OH', c: 'Franklin', a: ['columbus'] },
    { s: 'OH', c: 'Hamilton', a: ['cincinnati'] },
    { s: 'MI', c: 'Wayne', a: ['detroit'] },
    { s: 'MI', c: 'Oakland', a: ['troy', 'royal oak'] },
    { s: 'MI', c: 'Kent', a: ['grand rapids'] },
    { s: 'NC', c: 'Mecklenburg', wd: '2015-4423', a: ['charlotte'] },
    { s: 'NC', c: 'Wake', wd: '2015-4393', a: ['raleigh', 'cary'] },
    { s: 'NC', c: 'Guilford', a: ['greensboro', 'high point'] },
    { s: 'VA', c: 'Fairfax', a: ['fairfax', 'reston', 'tysons'] },
    { s: 'VA', c: 'Virginia Beach', wd: '2015-4341', a: ['virginia beach', 'norfolk', 'newport news', 'hampton'] },
    { s: 'VA', c: 'Richmond', wd: '2015-4313', a: ['richmond'] },
    { s: 'VA', c: 'Arlington', a: ['arlington'] },
    { s: 'VA', c: 'Henrico', a: ['henrico'] },
    { s: 'MD', c: 'Montgomery', a: ['bethesda', 'rockville', 'silver spring'] },
    { s: 'MD', c: 'Prince George\'s', a: ['hyattsville', 'bowie'] },
    { s: 'MD', c: 'Baltimore', a: ['baltimore'] },
    { s: 'MD', c: 'Anne Arundel', a: ['annapolis', 'glen burnie'] },
    { s: 'DC', c: 'District of Columbia', wd: '2015-4281', a: ['washington', 'dc', 'district of columbia'] },
    { s: 'WA', c: 'King', wd: '2015-5535', a: ['seattle', 'bellevue', 'tacoma', 'kent'] },
    { s: 'WA', c: 'Pierce', a: ['tacoma'] },
    { s: 'WA', c: 'Spokane', a: ['spokane'] },
    { s: 'AZ', c: 'Maricopa', wd: '2015-5469', a: ['phoenix', 'mesa', 'scottsdale', 'tempe', 'chandler', 'glendale'] },
    { s: 'AZ', c: 'Pima', a: ['tucson'] },
    { s: 'CO', c: 'Denver', wd: '2015-5419', a: ['denver', 'aurora', 'lakewood'] },
    { s: 'CO', c: 'Arapahoe', a: ['aurora', 'centennial'] },
    { s: 'CO', c: 'El Paso', a: ['colorado springs'] },
    { s: 'MA', c: 'Suffolk', a: ['boston'] },
    { s: 'MA', c: 'Middlesex', a: ['cambridge', 'lowell'] },
    { s: 'MA', c: 'Worcester', a: ['worcester'] },
    { s: 'MN', c: 'Hennepin', a: ['minneapolis', 'bloomington'] },
    { s: 'MN', c: 'Ramsey', a: ['st paul', 'saint paul'] },
    { s: 'MO', c: 'St. Louis', wd: '2015-5075', a: ['st louis', 'st. louis', 'saint louis'] },
    { s: 'MO', c: 'Jackson', a: ['kansas city'] },
    { s: 'TN', c: 'Davidson', a: ['nashville'] },
    { s: 'TN', c: 'Shelby', wd: '2015-4673', a: ['memphis'] },
    { s: 'TN', c: 'Knox', a: ['knoxville'] },
    { s: 'IN', c: 'Marion', wd: '2015-4787', a: ['indianapolis'] },
    { s: 'IN', c: 'Lake', a: ['gary', 'hammond'] },
    { s: 'OR', c: 'Multnomah', wd: '2015-5563', a: ['portland'] },
    { s: 'OR', c: 'Washington', a: ['beaverton', 'hillsboro'] },
    { s: 'OR', c: 'Lane', a: ['eugene'] },
    { s: 'LA', c: 'Orleans', a: ['new orleans'] },
    { s: 'LA', c: 'East Baton Rouge', a: ['baton rouge'] },
    { s: 'AL', c: 'Jefferson', a: ['birmingham'] },
    { s: 'AL', c: 'Montgomery', a: ['montgomery'] },
    { s: 'SC', c: 'Richland', a: ['columbia'] },
    { s: 'SC', c: 'Charleston', a: ['charleston', 'north charleston'] },
    { s: 'SC', c: 'Greenville', a: ['greenville'] },
    { s: 'OK', c: 'Oklahoma', a: ['oklahoma city'] },
    { s: 'OK', c: 'Tulsa', a: ['tulsa'] },
    { s: 'KS', c: 'Johnson', a: ['overland park', 'olathe'] },
    { s: 'KS', c: 'Wyandotte', a: ['kansas city'] },
    { s: 'KY', c: 'Jefferson', a: ['louisville'] },
    { s: 'KY', c: 'Fayette', a: ['lexington'] },
    { s: 'WI', c: 'Milwaukee', a: ['milwaukee'] },
    { s: 'WI', c: 'Dane', a: ['madison'] },
    { s: 'NE', c: 'Douglas', a: ['omaha'] },
    { s: 'NE', c: 'Lancaster', a: ['lincoln'] },
    { s: 'NM', c: 'Bernalillo', a: ['albuquerque'] },
    { s: 'UT', c: 'Salt Lake', a: ['salt lake city'] },
    { s: 'HI', c: 'Honolulu', wd: '2015-5689', a: ['honolulu'] },
    { s: 'AK', c: 'Anchorage', a: ['anchorage'] },
    { s: 'CT', c: 'Capitol', wd: '2015-4119', a: ['hartford', 'east hartford', 'middletown'] },
    { s: 'CT', c: 'Fairfield', a: ['bridgeport', 'stamford', 'norwalk'] },
    { s: 'NJ', c: 'Essex', a: ['newark'] },
    { s: 'NJ', c: 'Bergen', a: ['hackensack'] },
    { s: 'NJ', c: 'Middlesex', a: ['new brunswick'] },
    { s: 'IA', c: 'Polk', a: ['des moines'] },
    { s: 'AR', c: 'Pulaski', a: ['little rock'] },
    { s: 'MS', c: 'Hinds', a: ['jackson'] },
    { s: 'WV', c: 'Kanawha', a: ['charleston'] },
    { s: 'DE', c: 'New Castle', a: ['wilmington'] },
    { s: 'RI', c: 'Providence', a: ['providence'] },
    { s: 'NH', c: 'Hillsborough', a: ['manchester'] },
    { s: 'ID', c: 'Ada', a: ['boise'] },
    { s: 'MT', c: 'Yellowstone', a: ['billings'] },
    { s: 'SD', c: 'Minnehaha', a: ['sioux falls'] },
    { s: 'ND', c: 'Cass', a: ['fargo'] },
    { s: 'WY', c: 'Laramie', a: ['cheyenne'] },
    { s: 'VT', c: 'Chittenden', a: ['burlington'] },
    { s: 'ME', c: 'Cumberland', a: ['portland'] }
  ];

  var byState = {};
  var aliasIndex = {};

  function normKey(raw) {
    var s = String(raw == null ? '' : raw)
      .replace(/[\u2013\u2014]/g, '-')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    if (!s) return '';
    s = s.replace(/^(county|parish)\s+of\s+/i, '').trim();
    s = s.replace(/\b(county|parish|borough|census area|municipality|city and borough)\.?$/i, '')
      .replace(/\s+/g, ' ')
      .trim();
    return s;
  }

  function countyLabel(entry) {
    var c = entry.c;
    if (/county|parish|borough|district of columbia/i.test(c)) return c;
    return c + ' County';
  }

  function displayLabel(entry) {
    var label = countyLabel(entry);
    if (entry.a && entry.a.length) {
      var city = entry.a[0].replace(/\b\w/g, function (ch) { return ch.toUpperCase(); });
      if (city.toLowerCase() !== entry.c.toLowerCase()) {
        return city + ' (' + label + ')';
      }
    }
    return label;
  }

  function addAlias(key, entry) {
    if (!key) return;
    aliasIndex[key] = entry;
  }

  LOCALES.forEach(function (entry) {
    if (!byState[entry.s]) byState[entry.s] = [];
    byState[entry.s].push(entry);
    addAlias(normKey(entry.c), entry);
    (entry.a || []).forEach(function (alias) { addAlias(normKey(alias), entry); });
  });

  function findInState(state, key) {
    if (!key) return null;
    var st = String(state || '').toUpperCase().slice(0, 2);
    var hit = aliasIndex[key];
    if (hit && hit.s === st) return hit;
    var list = byState[st] || [];
    var i;
    for (i = 0; i < list.length; i++) {
      if (normKey(list[i].c) === key) return list[i];
    }
    return null;
  }

  function resolveKeys(raw) {
    var keys = [];
    var primary = normKey(raw);
    if (primary) keys.push(primary);
    var m = String(raw || '').match(/^(.+?)\s*\(([^)]+)\)\s*$/);
    if (m) {
      var a = normKey(m[1]);
      var b = normKey(m[2]);
      if (a && keys.indexOf(a) < 0) keys.push(a);
      if (b && keys.indexOf(b) < 0) keys.push(b);
    }
    return keys;
  }

  function suggestLabel(entry, query) {
    var q = normKey(query);
    var cl = countyLabel(entry);
    var cities = entry.a || [];
    var i, cityHit = '';
    for (i = 0; i < cities.length; i++) {
      if (tokenMatch(normKey(cities[i]), q)) { cityHit = cities[i]; break; }
    }
    if (cityHit) {
      var city = cityHit.replace(/\b[a-z]/g, function (ch) { return ch.toUpperCase(); });
      city = city.charAt(0).toUpperCase() + city.slice(1);
      return city + ' (' + cl + ')';
    }
    if (tokenMatch(normKey(entry.c), q) || tokenMatch(normKey(cl), q)) {
      var cityList = cities.slice(0, 3).map(function (c) {
        return c.replace(/\b\w/g, function (x) { return x.toUpperCase(); });
      }).join(', ');
      return cl + (cityList ? ' (' + cityList + ')' : '');
    }
    return displayLabel(entry);
  }

  function resolve(state, raw) {
    var st = String(state || '').toUpperCase().slice(0, 2);
    var stateName = STATE_NAMES[st] || st;
    var keys = resolveKeys(raw);
    if (!keys.length) {
      return { ok: false, error: 'Enter the county or major city of performance — SCA wage determinations are indexed by county.' };
    }

    var inState = null;
    var ki;
    for (ki = 0; ki < keys.length; ki++) {
      inState = findInState(st, keys[ki]);
      if (inState) break;
    }
    if (inState) {
      return {
        ok: true,
        state: st,
        county: inState.c,
        countyLabel: countyLabel(inState),
        label: displayLabel(inState),
        wd: inState.wd || null
      };
    }

    var elsewhere = null;
    for (ki = 0; ki < keys.length; ki++) {
      if (aliasIndex[keys[ki]] && aliasIndex[keys[ki]].s !== st) {
        elsewhere = aliasIndex[keys[ki]];
        break;
      }
    }
    if (elsewhere) {
      var otherName = STATE_NAMES[elsewhere.s] || elsewhere.s;
      var place = String(raw).trim();
      return {
        ok: false,
        mismatch: true,
        error: place + ' is in ' + otherName + ', not ' + stateName + '. Switch state to ' + otherName +
          ' or enter a ' + stateName + ' city/county.',
        suggestion: {
          state: elsewhere.s,
          county: elsewhere.c,
          countyLabel: countyLabel(elsewhere),
          wd: elsewhere.wd || null
        }
      };
    }

    return {
      ok: false,
      error: 'City not indexed. Enter the governing County to pull the correct SCA Wage Determination.',
      unindexed: true
    };
  }

  function tokenMatch(hay, needle) {
    if (!hay || !needle) return false;
    if (hay.indexOf(needle) >= 0) return true;
    var parts = needle.split(/\s+/).filter(Boolean);
    if (parts.length < 2) return false;
    return parts.every(function (p) { return hay.indexOf(p) >= 0; });
  }

  /** Typeahead: dual-key match on county name + city aliases (min 2 chars). */
  function search(state, query, limit) {
    var st = String(state || '').toUpperCase().slice(0, 2);
    var q = normKey(query);
    if (q.length < 2) return [];
    limit = limit || 8;
    var list = byState[st] || [];
    var results = [];
    var seen = {};
    list.forEach(function (entry) {
      var label = displayLabel(entry);
      if (seen[label]) return;
      var countyKey = normKey(entry.c);
      var match = tokenMatch(countyKey, q);
      if (!match) {
        match = tokenMatch(normKey(countyLabel(entry)), q);
      }
      if (!match) {
        (entry.a || []).some(function (alias) {
          if (tokenMatch(normKey(alias), q)) { match = true; return true; }
          return false;
        });
      }
      if (!match) return;
      seen[label] = true;
      var sug = suggestLabel(entry, query);
      results.push({
        label: sug,
        county: entry.c,
        countyLabel: countyLabel(entry),
        wd: entry.wd || null,
        value: sug
      });
    });
    return results.slice(0, limit);
  }

  function listForState(state) {
    var st = String(state || '').toUpperCase().slice(0, 2);
    var list = byState[st] || [];
    var out = [];
    var seen = {};
    list.forEach(function (entry) {
      var label = displayLabel(entry);
      if (seen[label]) return;
      seen[label] = true;
      out.push(label);
    });
    return out.sort();
  }

  global.OporaFedPop = {
    resolve: resolve,
    search: search,
    listForState: listForState,
    normKey: normKey,
    stateName: function (abbr) { return STATE_NAMES[String(abbr || '').toUpperCase()] || abbr; },
    countyFocused: false
  };
}(window));
